import Container from "@material-ui/core/Container";
import PrimaryCarousel from "../Carouselfold/CarouselComp";
import PrimaryDepro from "../HomeAbout";
import Primarymv from "../MissionandVision";
import Primarynews from "../Newsfold/Newsindex";
import Primaryqlinks from "../Quicklinks";
import SwipeableTextMobileStepper from "../Testimonials";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import ProjectsHome from "./projectsHome";
import ActivitiesHomeSection from "../Activityfold/ActivitiesHomeSection";

export default function Deskhome() {
  const matches = useMediaQuery("(min-width:840px)");
  return (
    <div id="bg">
      <div id="carsa">
        <PrimaryCarousel url_slug="carousel" child_url="home" />
      </div>
      <div id="botcardsadesk">
        <Container style={{ display: "flex" }}>
          <div id="lmain" style={{ 
          position: "relative", 
          zIndex: 10,
          transform: "translate3d(0,0,0)" 
        }}>
            <PrimaryDepro />
          </div>
          <div id="rmain">
            <div>
              <Primaryqlinks />
            </div>
            {<div id="newsindex">
              <Primarynews url_slug="newsblog" child_url="news" />
            </div>}
          </div>
        </Container>

        <div>
          <Primarymv child_url="home" />
        </div>

        <div>
          <SwipeableTextMobileStepper />
        </div>

        <div>
          <ActivitiesHomeSection />
        </div>

        <div>
           <ProjectsHome />
        </div>
      </div>
    </div>
  );
}
